export const isEmbedDashboard = () => {
    const embedPos = window.location.hash.toString().indexOf("embed/");

    // At least in Chrome 121 "location.hash" has "#" on start
    return embedPos === 0 || embedPos === 1;
};
